import { render, staticRenderFns } from "./Formulation.vue?vue&type=template&id=8001139c&"
import script from "./Formulation.vue?vue&type=script&lang=js&"
export * from "./Formulation.vue?vue&type=script&lang=js&"
import style0 from "./Formulation.vue?vue&type=style&index=0&id=8001139c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports